import { render, staticRenderFns } from "./rune-editor.vue?vue&type=template&id=2f18dbdb&scoped=true&"
import script from "./rune-editor.ts?vue&type=script&lang=ts&"
export * from "./rune-editor.ts?vue&type=script&lang=ts&"
import style0 from "./rune-editor.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./rune-editor.vue?vue&type=style&index=1&id=2f18dbdb&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f18dbdb",
  null
  
)

export default component.exports